import React from 'react';
import { formatCampaignMoney } from '../../utils/campaignCurrency';
import { WalletTransactionsPage } from '../../services/walletService';
import { describeWalletTransaction, formatWalletDate } from './walletTransactionCopy';

type Props = {
  transactions: WalletTransactionsPage;
  loadingPage: boolean;
  onPageChange: (page: number) => void;
};

const WalletTransactionHistory: React.FC<Props> = ({
  transactions,
  loadingPage,
  onPageChange,
}) => (
  <section className="earnings-dashboard__history">
    <div className="history-header">
      <h3>Transaction history</h3>
      {loadingPage ? <span>Loading page...</span> : null}
    </div>

    {transactions.items.length === 0 ? (
      <p className="analytics-empty">No wallet transactions yet.</p>
    ) : (
      <div className="history-table-wrap">
        <table className="history-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Description</th>
              <th>Currency</th>
              <th>Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {transactions.items.map(transaction => (
              <tr key={transaction._id}>
                <td>{formatWalletDate(transaction.createdAt)}</td>
                <td>{describeWalletTransaction(transaction.referenceKey)}</td>
                <td>{transaction.currencyCode}</td>
                <td className={`wallet-amount wallet-amount--${transaction.type}`}>
                  {transaction.type === 'cr' ? '+' : '-'}
                  {formatCampaignMoney(transaction.amount, transaction.currencyCode)}
                </td>
                <td>
                  <span
                    className={`status-chip status-chip--${
                      transaction.status === 'eligible'
                        ? 'pending'
                        : transaction.status === 'pending'
                          ? 'pending'
                          : 'completed'
                    }`}
                  >
                    {transaction.status === 'eligible'
                      ? 'Eligible'
                      : transaction.status === 'pending'
                        ? 'Pending'
                        : 'Available'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}

    <div className="history-pagination">
      <button
        type="button"
        disabled={transactions.pagination.page <= 1 || loadingPage}
        onClick={() => onPageChange(transactions.pagination.page - 1)}
      >
        Previous
      </button>
      <span>
        Page {transactions.pagination.page} of {Math.max(transactions.pagination.totalPages, 1)}
      </span>
      <button
        type="button"
        disabled={
          transactions.pagination.page >= transactions.pagination.totalPages || loadingPage
        }
        onClick={() => onPageChange(transactions.pagination.page + 1)}
      >
        Next
      </button>
    </div>
  </section>
);

export default WalletTransactionHistory;
